module.exports = __webpack_public_path__ + "img/qfcmBanner.e36011a1.png";